export default __webpack_public_path__ + "static/media/info.4754d977.svg";